import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { carSearch } from '../../../../../store/slices/car';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import carSearchInput from '../../../../../helpers/selectors/carSearchInput';
import { setCarTripSearchInputs } from '../../../../../store/slices/tripSearch';

const RentalAgencyFilter = ({ tripId, selectedTab, bgClassName }) => {
  const isTripSearch = !tripId;
  const { searchInputs, responseFilters } = useSelector(
    carSearchInput(tripId, selectedTab, isTripSearch),
  );
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (newValue) => {
      if (isTripSearch) {
        dispatch(
          setCarTripSearchInputs({
            page: 1,
            rentalCarAgencies: newValue,
          }),
        );
      } else {
        dispatch(
          carSearch({
            tripId,
            selectedTab,
            searchObj: {
              ...searchInputs,
              page: 1,
              rentalCarAgencies: newValue,
            },
          }),
        );
      }
    },
    [isTripSearch, dispatch, tripId, selectedTab, searchInputs],
  );

  return (
    <>
      {responseFilters.rentalAgencyResults && responseFilters.rentalAgencyResults.length ? (
        <CheckboxSelectFilter
          options={responseFilters.rentalAgencyResults || []}
          values={searchInputs.rentalCarAgencies}
          onChange={handleChange}
          widthInside="max-w-85"
          label="Rental agency"
          variant={!isTripSearch ? 'outline' : undefined}
          bgClassName={!isTripSearch ? '' : bgClassName}
        />
      ) : (
        <></>
      )}
    </>
  );
};

RentalAgencyFilter.propTypes = {
  tripId: PropTypes.string,
  bgClassName: PropTypes.string,
  selectedTab: PropTypes.number,
};

RentalAgencyFilter.defaultProps = {
  tripId: undefined,
  bgClassName: undefined,
  selectedTab: 0,
};
export default memo(RentalAgencyFilter);
